import { createSmartAccount } from '../createSmartAccountClient';
import { ERC4337 } from '../../../../constants';
import { toSimpleSmartAccount } from 'permissionless/accounts';
import { entryPoint06Address } from 'viem/account-abstraction';
export async function simpleSmartAccount(args) {
    const { owner, address, publicRpcClient } = args;
    const smartAccountImpl = {
        ...(await toSimpleSmartAccount({
            owner,
            address,
            nonceKey: 0n, // should also be 0n b/c viem's default is not?
            // 0n was original nonce for useropsjs
            index: 0n,
            client: publicRpcClient,
            entryPoint: {
                address: entryPoint06Address,
                version: '0.6',
            },
        })),
    };
    return createSmartAccount({
        ...args,
        entrypointAddress: entryPoint06Address,
        factoryAddress: ERC4337.SimpleAccount.Factory,
        smartAccountImpl,
        publicRpcClient,
    });
}
